export const AGENT_PROFILE_BASE_PATH = "/profile";

export const getNotFoundRedirectUrl = (lang: string) =>
  ({
    en: "https://www.prudential.com.hk/scws/pages/en/contact-us/make-appointment/index.html",
    zhhk: "https://www.prudential.com.hk/scws/pages/tc/contact-us/make-appointment/index.html",
  }[lang]);
